export default __webpack_public_path__ + "static/media/refund.c06dd5c6.png";